function mediaQueriesSupported() {
  return (typeof window.matchMedia !== 'undefined' || typeof window.msMatchMedia !== 'undefined');
}

const is_lg = function () {
  if (mediaQueriesSupported()) {
    if (window.matchMedia('(min-width: 1201px)').matches) {
      return true;
    }

    return false;
  }

  return false;
};

const is_md = function () {
  if (mediaQueriesSupported()) {
    if (window.matchMedia('(min-width: 901px) and (max-width: 1200px)').matches) {
      return true;
    }

    return false;
  }

  return false;
};

const is_md_and_smaller = function () {
  if (mediaQueriesSupported()) {
    if (window.matchMedia('(max-width: 1200px)').matches) {
      return true;
    }

    return false;
  }

  return false;
};

const is_sm = function () {
  if (mediaQueriesSupported()) {
    if (window.matchMedia('(min-width: 601px) and (max-width: 900px)').matches) {
      return true;
    }

    return false;
  }

  return false;
};

const is_sm_and_smaller = function () {
  if (mediaQueriesSupported()) {
    if (window.matchMedia('(max-width: 900px)').matches) {
      return true;
    }

    return false;
  }

  return false;
};

const is_xs = function () {
  if (mediaQueriesSupported()) {
    if (window.matchMedia('(max-width: 600px)').matches) {
      return true;
    }

    return false;
  }

  return false;
};

